import { SxProps } from "@mui/material";

export const sxCertificationItem: SxProps = {
  display: "flex",
  flexDirection: "row",
  gap: "8px",
};

const sxPremioIconBase = {
  marginLeft: "80px",
  width: 70,
  height: 70,
  minWidth: 40,
  minHeight: 40,
  borderRadius: 1,
  flexShrink: 0,
} as const;

export const sxPremioIconPlaceholder: SxProps = {
  ...sxPremioIconBase,
  bgcolor: "rgba(28, 55, 117, 0.08)",
};

export const sxPremioIcon: SxProps = {
  ...sxPremioIconBase,
  objectFit: "contain",
};

export const sxPremioIconPlaceholderXs: SxProps = {
  width: 32,
  height: 32,
  minWidth: 32,
  minHeight: 32,
  borderRadius: 1,
  bgcolor: "rgba(28, 55, 117, 0.08)",
  flexShrink: 0,
};

export const sxPremioIconXs: SxProps = {
  width: 32,
  height: 32,
  minWidth: 32,
  minHeight: 32,
  borderRadius: 1,
  objectFit: "contain",
  flexShrink: 0,
};

export const sxAnoHeader: SxProps = {
  fontFamily: "Montserrat-Bold",
  fontStyle: "italic",
  fontSize: "var(--font-size-medium)",
  color: "var(--primary-blue)",
  marginBottom: 0.5,
};

export const sxAnoHeaderXs: SxProps = {
  fontFamily: "Montserrat-Bold",
  fontSize: "14px",
  color: "var(--primary-blue)",
  marginBottom: 0.5,
};

export const sxItalicText: SxProps = {
  fontFamily: "Montserrat-Italic",
  fontSize: "var(--font-size-small)",
};

export const sxItalicTextXs: SxProps = {
  fontFamily: "Montserrat-Italic",
  fontSize: "14px",
};

export const sxBoldText: SxProps = {
  fontFamily: "Montserrat-Bold",
  fontSize: "var(--font-size-small)",
};

export const sxBoldTextXs: SxProps = {
  fontFamily: "Montserrat-Bold",
  fontSize: "14px",
};